<template>
  <d-modal
    @close="handleClose"
    size="lg">
    <d-modal-header>
      <d-modal-title>
        {{ $t('ui.editionsHistory.diffPopup.title') }}
      </d-modal-title>
    </d-modal-header>

    <d-modal-body class="p-0">
      <d-alert
        v-if="!loaded && !loadError"
        show
        theme="light">
        {{ $t('ui.dataLoading') }}
      </d-alert>

      <d-alert
        v-if="loadError"
        show
        theme="danger">
        {{ $t('ui.errorOccuredDesc') }}
      </d-alert>

      <table
        v-if="loaded && !loadError"
        class="table">
        <thead>
          <tr>
            <th>{{ $t('ui.editionsHistory.diffPopup.fieldName') }}</th>
            <th>{{ $t('ui.editionsHistory.diffPopup.previousValue') }}</th>
            <th>{{ $t('ui.editionsHistory.diffPopup.currentValue') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(diffItem, index) of differences"
            :key="'diff-item-' + index">
            <td>
              {{ diffItem.field }}
            </td>
            <td>
              {{ diffItem.before }}
            </td>
            <td>
              {{ diffItem.after }}
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'editions-history-diff-popup',
  props: {
    endpointBase: {
      type: String,
      required: true
    },
    historyItemId: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      loaded: false,
      loadError: false,
      differences: []
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      FormUtils.loadItemData(this, {
        method: 'get',
        endpointBase: this.endpointBase + '/item/',
        instanceFields: ['differences'],
        loadedKey: 'loaded',
        errorKey: 'loadError',
        overrideID: parseInt(this.historyItemId, 10)
      });
    },
    handleClose () {
      this.$emit('close');
    }
  }
}
</script>
